import React from 'react'
import { track } from '@amplitude/unified'

// import { Swiper, SwiperSlide } from "swiper/react";

// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";


// // import required modules
// import { Mousewheel, Pagination } from "swiper";

const team = [
  
  { 
    image: "/images/profile/Jenna.jpg",
    name: "Jen",
    title: "Managing Director",
    background: "#FBF6E4",
    imagebackground: "#F8F0D3",
    paragraph: "Jen’s done it all — from leading solar startups, managing network operations, to advising on demand-side strategies and consulting. Now at Rishi, she’s channelling that powerhouse experience into supporting our sales team — with insight, drive, and non-stop energy - Buckle up!"
  },
  {
    image: "/images/profile/Dhivya.jpg",
    name: "Dhivya",
    title: "Founder & CTO",
    background: "#FBEFE4",
    imagebackground: "#F8E5D3",
    paragraph: "Dhivya started it all! She’s our Big Data slayer with a wealth of experience across major platforms and industries. Her Savvy Insights wield the power of data, driving Rishi’s success. She’s the secret sauce in our Big Data recipe."
  },
  {
    image: "/images/profile/Yadhunandan.jpg",
    name: "Yadhu",
    title: "Product Lead",
    background: "#E4FBED",
    imagebackground: "#CAF7DB",
    paragraph: "A full-on tech enthusiast, Yadhu brings to the table great wealth of experience in product management and delivery. He is that kind of a nerd who enjoys attending tech conferences, learning from them, and schooling us mortals."
  },
  {
    image: "/images/profile/Vivek.jpg",
    name: "Vivek",
    title: "DevOps & <br/> Infra Lead",
    background: "#E4E7FB",
    imagebackground: "#D3D8F8",
    paragraph: "Vivek has diverse experience across several programming, cloud platforms and cross functional experience. He is our man who is on a mission of keeping the service reliable and scalable for all our clients. Keep your phones and scales handy mate!"
  },
  // {
  //   image: "/images/vinodh.png",
  //   name: "Vinodh",
  //   title: "Advisor",
  //   background: "#E4F8FB",
  //   imagebackground: "#D3F3F8",
  //   paragraph: "Introducing Vinodh, one of our subject matter experts in the solar industry with a strong background in project management. He excels at breaking down complex requirements into techie-friendly bytes. He’s also incredibly organized, driven, and bald."
  // },
  {
    image: "/images/profile/Emre.jpg",
    name: "Emre",
    title: "Advisor",
    background: "#E4E7FB",
    imagebackground: "#D3D8F8",
    paragraph: "Our solar industry superhero, Emre has been in the deep end of the EPC side of things. He is the guardian of our product’s purpose and a much-needed reality check whenever we get too into our heads."
  }
]


// export default function OurTeam() {
//   return (
//     <>
//     <section className="team" id='our-team'>
//         <div className="container">
//             <div className="team__header text-center">
//                 <h2>Our Team</h2>
//             </div>
//             <Swiper
//         direction={"vertical"}
//         slidesPerView={1}
//         spaceBetween={30}

//         mousewheel={true}
//         pagination={{
//           clickable: true,
//         }}

//         modules={[Mousewheel, Pagination]}
//         className="mySwiper"
//       >
//         {
//           team.map((ele, index)  =>{
//           return( <SwiperSlide key={index}>
//             <div className="row">
//                 <div className="col-sm-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-center">
//                     <div className="team__img">
//                         <img src={ele.image} alt="" />
//                     </div>
//                 </div>
//                 <div className="col-sm-12 col-md-6 col-lg-6">
//                   <div className="team__name">
//                     <h3>{ele.name}</h3>
//                   </div>
//                   <div className="team__title mt-3">
//                     <h4>{ele.title}</h4>
//                   </div>
//                   <div className="team__paragraph mt-5">
//                     <p>{ele.paragraph}</p>
//                   </div>
//                 </div>
//             </div>
//         </SwiperSlide>  
//           )}
//           )
//         }
//       </Swiper>
//         </div>
//     </section>
//     </>
//   )
// }

export default function OurTeam() {
  return (
    <>
      <section className="team" id='our-team'>
        <div className="container">
          <div className="team__header text-center">
            <h2>Our Team</h2>
          </div>
          <div className="row mt-5 justify-content-center" style={{ rowGap: "25px" }}>
            {
              team.map((ele, index) => {
                return (<div style={{"min-width": "300px", maxWidth:"500px"}} className="col-lg-4">
                  <div
                    className="animation team-hover-card"
                    onMouseEnter={e => {
                      e.currentTarget._hoverTimeout = setTimeout(() => {
                        track('Team Member Viewed', { teamMemberName: ele.name, position: ele.title });
                      }, 3000);
                    }}
                    onMouseLeave={e => {
                      clearTimeout(e.currentTarget._hoverTimeout);
                    }}
                  >
                    <div className="team__container" style={{background: `${ele.background}`}} key={index.image}>
                      <div data-aos="flip-left"  data-aos-easing="ease-out-cubic" data-aos-delay={100*index} data-aos-duration="100" className="team__img" style={{background: `${ele.imagebackground}`}}>
                        <img src={ele.image} alt="" />
                      </div>
                      <div className="team--details" style={{width:"50%"}}>
                        <div className="team__name mt-3">
                          <h3>{ele.name}</h3>
                        </div>
                        <div className="team__title mt-3">
                          <div dangerouslySetInnerHTML={{__html:ele["title"]}}></div>
                        </div>
                      </div>
                    </div>
                    <div className="team__paragraph mt-4">
                      <p>{ele.paragraph}</p>
                    </div>
                  </div>                  
                </div>
                )
              })
            }
          </div>
        </div>
      </section>
    </>
  )
}